import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const perks = [{
  emoji: '💳',
  text: 'One-time payment'
}, {
  emoji: '🔓',
  text: 'Lifetime access'
}, {
  emoji: '⚡',
  text: 'Instant digital access'
}, {
  emoji: '🌎',
  text: 'Automatic currency conversion where applicable'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-187" data-mp="ty1udy55929s">
      <div className="mx-auto max-w-xl" data-id="element-188" data-mp="p00cvhnd9b0f">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-189" data-mp="p11wwbmd17ua">
          Total value stack
        </h2>

        <dl className="mt-7 overflow-hidden rounded-2xl border border-white/10 bg-navy-950" data-id="element-190" data-mp="yy7pjoamh6wm">
          <div className="flex items-center justify-between gap-4 border-b border-white/10 px-4 py-4" data-id="element-191" data-mp="2fbxvl0lay58w">
            <dt className="text-sm font-600 uppercase tracking-wide text-slate-200" data-id="element-192" data-mp="2add4prrxwxx4">
              DVO Master Protocol™ — 6 volumes
            </dt>
            <dd className="font-display text-xl font-700 text-slate-400 line-through" data-id="element-193" data-mp="pjp8ru1dymmr">$197</dd>
          </div>
          <div className="flex items-center justify-between gap-4 border-b border-white/10 px-4 py-4" data-id="element-194" data-mp="uhh4kz55isw8">
            <dt className="text-sm font-600 uppercase tracking-wide text-slate-200" data-id="element-195" data-mp="zgag4m0vo9tr">
              5 exclusive bonuses
            </dt>
            <dd className="font-display text-xl font-700 text-slate-400 line-through" data-id="element-196" data-mp="6u9918xiyy7e">$177</dd>
          </div>
          <div className="flex items-center justify-between gap-4 bg-navy-800 px-4 py-4" data-id="element-197" data-mp="bs1060qcigaj">
            <dt className="font-display text-base font-700 uppercase tracking-wide text-white" data-id="element-198" data-mp="ftw0p30gcpn9">
              Total value
            </dt>
            <dd className="font-display text-2xl font-700 text-white" data-id="element-199" data-mp="kmp4noo3jtya">$374 USD</dd>
          </div>
        </dl>

        <div className="mt-8 rounded-2xl border-2 border-gold-500 bg-navy-950 p-5 text-center sm:p-7" data-id="element-200" data-mp="3k8doh3gm4zrw">
          <p className="text-[11px] font-700 uppercase tracking-[0.22em] text-gold-400" data-id="element-201" data-mp="3o84lhowqgc4v">
            Today you get everything for just
          </p>
          <p className="mt-2 font-display text-6xl font-700 leading-none text-white sm:text-7xl" data-id="element-202" data-mp="qhfn7rcq129z">
            $27
            <span className="ml-2 align-middle font-display text-xl font-600 text-gold-400" data-id="element-203" data-mp="154ikpy11naxb">
              USD
            </span>
          </p>

          <ul className="mt-6 space-y-2 text-left" data-id="element-204" data-mp="108tghhe2x5uo">
            {perks.map(perk => <li key={perk.text} className="flex items-start gap-3" data-id="element-205" data-mp="ciz5z6h8ftdl">
                <span className="text-base leading-none" aria-hidden="true" data-id="element-206" data-mp="7j3bbxufdeap">
                  {perk.emoji}
                </span>
                <span className="text-sm leading-snug text-slate-200" data-id="element-207" data-mp="lfgj2f95q1bz">{perk.text}</span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-208" data-mp="1ww6t69gpbdav">
            <CTAButton label="Yes, I want DVO Master Protocol™ — $27" subtext="Instant access · Lifetime access · 7-day guarantee" data-id="element-209" data-mp="1wvev8rzmt3hf" />
          </div>

          <div className="mt-6" data-id="element-210" data-mp="20dm3fyunug1v">
            <Countdown data-id="element-211" data-mp="20gqgllq3sm4o" />
          </div>

          <div className="mt-6" data-id="element-212" data-mp="25e9w0oyjf4y7">
            <ScarcityBar data-id="element-213" data-mp="25eibmom1ood3" />
          </div>

          <p className="mt-5 text-xs leading-relaxed text-slate-400" data-id="element-214" data-mp="1qghho04q8mll">
            The promotional price is available while this offer remains active. Prices are shown in
            USD and your currency is converted automatically at checkout where applicable.
          </p>
        </div>
      </div>
    </section>;
}